<template>
  <div class="container" id="DEVELOP-PROGRESS">
    <div class="common-title">
      <div class="common-title-content">
        发展历程
      </div>
    </div>
    <div class="grid">
      <div
        class="bg"
        :style="{ transform: `translate3d(${computedDistance})` }"
      ></div>
      <div class="bg-modal"></div>
      <div class="dateline">
        <div class="line"></div>
        <div class="container">
          <div class="date">
            <div
              class="date-item"
              :class="currentIdx == index ? 'active' : ''"
              v-for="(item, index) in yearList"
              :key="index"
              @mouseover="handleMouseOver(item, index)"
            >
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="path" v-for="(year, index) in yearList" :key="index"></div>
      </div>
      <div class="content">
        <div
          class="slide"
          :class="currentIdx == index ? 'active animated fadeIn' : ''"
          v-for="(content, index) in contents"
          :key="index"
        >
          <div class="text" v-html="content.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressCom",
  data() {
    return {
      yearList: ["2016", "2017", "2018", "2019", "2020", "2021"],
      contents: [
        {
          text:
            "<p style='margin-bottom:0.5rem;'>十三五第一年，亦是我国构建共建共治共享社会治理格局的开局之年。全景智联率先在广州市启动了我国第一个城中村门禁智能化改造项目。依托智能门禁，有效地管理好了流动人口，织牢了社会治理的治安防控网络。</p><p style='margin-bottom:0.5rem;'>形成了以物联网技术为核心的智慧社区解决方案。</p>"
        },
        {
          text:
            "<p style='margin-bottom:0.5rem;'>打造了湖北省第一个“物联网+社区警务”模式的智慧社区，成为武汉市智慧社区样板，公安部副部长王小洪同志及各省市公安政法机关多次参观。</p><p style='margin-bottom:0.5rem;'>智慧模式落地武汉市经济开发区，建成了武汉经济开发区首个智慧社区，有效解决了小区传销猖獗的问题。</p><p style='margin-bottom:0.5rem;'>在小区内提出“民警+网格+社区志愿者”多方联动，“技防”+“人防”，创新治理模式，实现社区的共建共治共享。</p>"
        },
        {
          text:
            "<p style='margin-bottom:0.5rem;'>大力推进智慧社区建设，在全国9个城市，部署了34个社区。</p><p style='margin-bottom:0.5rem;'>建成武汉市最大体量的区域级智慧社区项目，打造了智慧社区“建设+运维+运营”标杆案例。</p><p style='margin-bottom:0.5rem;'>多次参与智慧社区行业标准制定，技术转化能力获得社会认可，为企业赢得了更高的发展平台。</p><p style='margin-bottom:0.5rem;'>抢占市场，率先在合肥市蜀山区和青岛市即墨区打造了当地首个智慧社区。为规模化推广奠定了坚实的基础。</p>"
        },
        {
          text:
            "<p style='margin-bottom:0.5rem;'>加速拓展业务版图，全国范围内部署的智慧社区达66个。</p><p style='margin-bottom:0.5rem;'>自研的智慧社区大数据平台上线，能够为社区场景数据治理和数据服务提供强有力的数据支撑。</p><p style='margin-bottom:0.5rem;'>上线屋畔社区服务APP，让社区运营有抓手，服务真正下沉到居民身边。</p><p style='margin-bottom:0.5rem;'>率先在武汉市东湖高新区智慧社区（20个）开展社区运营活动，沉淀出全景智联智慧社区运营模式，并成功在其他社区复制推广。</p>"
        },
        {
          text:
            "<p style='margin-bottom:0.5rem;'>与平安集团·平安智慧城签订战略合作协议，构建智慧社区新生态。</p><p style='margin-bottom:0.5rem;'>践行企业社会责任，科技抗疫，驰援武汉。用科技守护生命，实现方舱医院医护、病人0感染。</p><p style='margin-bottom:0.5rem;'>在北京市、青岛市等地落地智慧社区，逐渐形成以华北、华东、华中地区一线城市为主的业务布局。</p><p style='margin-bottom:0.5rem;'>新华网、人民日报、人民网专题报道全景智联智慧社区，探讨数据治理、服务模式。</p><p style='margin-bottom:0.5rem;'>智慧社区解决方案迭代，引入边缘计算技术。并成功研发QJ-E8系列智慧城市微场景边缘计算服务器，打通数据传输的“最后一公里”，保证强大算力和高吞吐量的数据存储。</p><p style='margin-bottom:0.5rem;'>全景智联智慧社区解决方案亮相第三届中国进口博览会，并为主办方研发了国家会展中心防疫子系统，再次用科技手段为进博会人员安全保驾护航。</p><p style='margin-bottom:0.5rem;'>再次参与城市老旧小区智能化改造国家团体技术标准制定，积极推动新基建体系下智慧社区行业应用逐渐向标准化、体系化转变。</p><p style='margin-bottom:0.5rem;'>与华中师范大学签订合作协议，开展市域治理现代化产学研究。</p><p style='margin-bottom:0.5rem;'>成为云天励飞最大的系统集成供应商，持续为合作伙伴输入最优质的服务。</p>"
        },
        {
          text:
            "<p style='margin-bottom:0.5rem;'>完成A轮融资，股东为京东科技。</p><p style='margin-bottom:0.5rem;'>成功入选武汉市首批人工智能企业名单，技术创新应用能力获得认证。</p><p style='margin-bottom:0.5rem;'>截止到2021年7月，建设运营社区（含街道）共663个。 </p><p style='margin-bottom:0.5rem;'>在上海市、湖北省荆门市启动街道智慧化建设工作，智慧网格、智慧街道的成功落地让全景智联“以数据为核心”的市域治理解决方案和战略规划得到了市场认证。</p><p style='margin-bottom:0.5rem;'>科技抗疫案例入选商务部主管的“金钥匙——面向SDG的中国行动”优胜奖。</p><p style='margin-bottom:0.5rem;'>再次参与起草的行业标准—DB42/T 1554-2020《智慧社区工程设计与验收规范》发布，表明了企业助力行业可持续发展的决心和能力。</p><p style='margin-bottom:0.5rem;'>坚持探索、沉淀社区运营服务模式，落地线下屋畔社区运营服务中心，实现社区运营服务业务重大跨越。</p><p style='margin-bottom:0.5rem;'>青岛市即墨区养生谷智慧社区入选山东省新型智慧城市惠民领域优秀案例。</p><p style='margin-bottom:0.5rem'>公司率先启动了区域级市域治理试点——武汉市东湖高新区智慧平安小区（二期）。</p><p style='margin-bottom:0.5rem;'>更多精彩，敬请期待······</p>"
        }
      ],
      currentIdx: 0,
      distance: 0
    };
  },
  computed: {
    computedDistance() {
      let distance = -this.currentIdx * 5 + "vw";
      return `${distance},0,0`;
    }
  },
  methods: {
    handleMouseOver(item, index) {
      this.currentIdx = index;
    }
  }
};
</script>
<style lang="less" scoped>
.grid {
  position: relative;
  width: 100%;
  height: 49.1rem;
  overflow: hidden;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 125vw;
    height: 100%;
    background-image: url("~@/assets/images/aboutUs/progress_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 0 top;
    transition: all 1s ease;
  }
  .bg-modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
  }
  .dateline {
    position: absolute;
    bottom: 8.15rem;
    left: 0;
    width: 100%;
    z-index: 100;
    .line {
      width: 100%;
      height: 1px; /*no*/
      transform: scale(1, 1);
      // height: 1px;
      // background: #e6e6e6;
      // border: 1px solid #e6e6e6;
      background-color: #e6e6e6;
    }
    .container {
      position: absolute;
      left: 50%;
      max-width: 52.35rem;
      width: 52.75rem;
      height: 4rem;
      margin: 0 auto;
      transform: translate(-50%, -50%);
      .date {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        text-align: center;
        .date-item {
          width: 4rem;
          height: 100%;
          text-align: center;
          transition: all 0.3s ease;
          &.active {
            width: 30rem;
            span {
              padding: 0 0 0 3rem;
              font-size: 4rem;
              font-weight: bold;
              &::after {
                left: 30%;
                background-color: #007aff;
              }
            }
          }
          span {
            position: relative;
            display: inline-block;
            width: 100%;
            line-height: 1;
            padding-top: 3rem;
            font-size: 1rem;
            color: #ffffff;
            &::after {
              content: "";
              position: absolute;
              top: 2rem;
              left: 50%;
              width: 0.8rem;
              height: 0.8rem;
              background-color: #7799cd;
              border-radius: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
  .content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 10.2rem 38rem 0 11.5rem;
    font-size: 0.9rem;
    font-weight: 500;
    color: #ffffff;
    line-height: 1.7rem;
    z-index: 99;
    .slide {
      display: none;
      opacity: 0;
      animation: 0.3s fadeInRightBig;
      .text /deep/ p {
        position: relative;
        padding-left: 1rem;
        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          top: 0.7rem;
          left: 0.3rem;
          width: 0.2rem;
          height: 0.2rem;
          background-color: #ffffff;
          border-radius: 50%;
        }
      }
      &.active {
        display: block;
        opacity: 1;
      }
    }
  }
}
</style>
